import { render, staticRenderFns } from "./TerminalPage.vue?vue&type=template&id=7d966496"
import script from "./TerminalPage.vue?vue&type=script&lang=js"
export * from "./TerminalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports